import { lowercase } from './lowercase';
import { removeNonWord } from './remove-non-word';

export function kebabcase(value: string | null): string {
    if (value === null) {
        return '';
    }

    return removeNonWord(lowercase(value))
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)!
        .map(x => x.toLowerCase())
        .join('-');
}
